(function() { module.exports = window["URI"]; }());


//////////////////
// WEBPACK FOOTER
// external "URI"
// module id = 5
// module chunks = 88